export default __webpack_public_path__ + "static/media/semercioglu2.034ffe61.jpg";